import {
  ComesInGoesOutUnderline,
  GoesOutComesInUnderline,
} from "@/components/ui/underline-animation";
import { useCursor } from "@/context/CursorContext";
import Logo from "@/components/Logo";

const Footer = () => {
  const { setCursorVariant, setCursorText } = useCursor();

  function contactEnter(event) {
    setCursorText("👋");
    setCursorVariant("contact");
  }

  function contactLeave(event) {
    setCursorText("");
    setCursorVariant("default");
  }

  return (
    <footer
      id="contact"
      className="mt-12 relative py-16 text-background overflow-hidden"
    >
      <div className="absolute top-0 z-[-2]  h-full w-full bg-white bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))]"></div>
      <div className="container grid md:grid-cols-2">
        <div className="mx-auto max-w-2xl">
          <div className="mb-12">
            <Logo variant="light" />
          </div>
          <h2 className="text-3xl md:text-5xl tracking-tighter  text-left font-regular mb-6">
            Let’s talk about your project.
          </h2>
          <p className="text-lg font-medium opacity-80">
            Drop me a message or connect via social channels. I’m always open to
            new ideas.
          </p>
        </div>

        <div>
          <div className="flex flex-col md:justify-end md:items-end gap-6 mt-10">
            <a
              onMouseEnter={contactEnter}
              onMouseLeave={contactLeave}
              href="mailto:contact@webbyj.io"
              className="flex gap-4 items-center text-3xl group font-medium transition-all"
              target="_blank"
            >
              <GoesOutComesInUnderline label="contact@webbyj.io" />
            </a>
            <div className="flex flex-col md:items-end text-end gap-2">
              <a
                href="https://www.linkedin.com/in/jakub-wawrysiewicz/"
                className="flex gap-4 items-center text-xl font-medium transition-all"
                target="_blank"
              >
                <ComesInGoesOutUnderline label="LinkedIn" />
              </a>
              <a
                href="https://github.com/wawrysiewiczj"
                className="flex gap-4 items-center text-xl font-medium  transition-all"
                target="_blank"
              >
                <ComesInGoesOutUnderline label="GitHub" direction="right" />
              </a>
            </div>
          </div>
          <div className="mt-12 md:text-right text-xs">
            <p>
              Copyright &copy; {new Date().getFullYear()} www.webbyj.io. All
              Right Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
